import React from "react"
import { Container, Row, Col, Button, Form, Card } from "react-bootstrap"
import { Formik, Field, ErrorMessage } from "formik"
import * as Yup from "yup"
import { getMyProfile, patchUser } from "../../api/api_user"
import Select from "react-select"
import * as CountryIcon from "country-flag-icons/react/3x2"
import Cookies from "universal-cookie"
import withHooks from "../../Common/jsx/WithHooks"
import { cleanEntity } from "../../Common/js/clean_entity"

class MyProfileForm extends React.Component {
  constructor(props) {
    super(props)

    this.dMgr = this.props.DebugManager(this.constructor.name)
    this.dMgr.debug("const_props:", this.props)

    this.cookies = new Cookies()

    this.state = {
      isReadyToRender: false,
      disable_button_validate: false,
      entity: {},
    }

    this.dMgr.debug("init_state:", this.state)

    this.getFormValidationSchema = this.getFormValidationSchema.bind(this)
    this.lockAndSubmit = this.lockAndSubmit.bind(this)
    this.getEntity = this.getEntity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    this.getEntity()
  }

  async getEntity() {
    let entity = await getMyProfile()
    this.dMgr.debug("getEntity:", entity)
    this.setState({ entity, isReadyToRender: true })
  }

  getFormValidationSchema() {
    return Yup.object().shape({
      firstname: Yup.string().required(this.props.t("message.required")),
      name: Yup.string().required(this.props.t("message.required")),
      iamUsername: Yup.string().required(this.props.t("message.required")),
      email: Yup.string().email("Bgalid email").required(this.props.t("message.required")),
    })
  }

  async lockAndSubmit(values, { setSubmitting }) {
    this.dMgr.debug("lockAndSubmit:", values)
    this.setState({ disable_button_validate: true }, () => this.handleSubmit(values, { setSubmitting }))
  }

  async handleSubmit(values, { setSubmitting }) {
    this.dMgr.debug("handleSubmit:", values)

    let entity = cleanEntity(values)
    let patchEntity = {
      name: entity.name,
      firstname: entity.firstname,
      preferredLanguage: entity.preferredLanguage,
    }

    try {
      // CONFIG ==================================================================================================

      this.dMgr.debug("patch entity:", entity.id, patchEntity)
      let newEntity = await patchUser(entity.id, patchEntity)

      this.dMgr.debug("success entity:", newEntity.id, newEntity)

      let currentUser = { ...this.cookies.get("bg_user"), name: entity.name, firstname: entity.firstname, preferredLanguage: entity.preferredLanguage }
      this.dMgr.debug("new cookie entity:", currentUser)
      this.cookies.set("bg_user", currentUser)

      this.props.notif.success()
      this.props.router.nav({
        prefix: "admin",
        url: "/dashboard",
      })

      // /CONFIG =================================================================================================
    } catch (err) {
      this.dMgr.error("COUGHT EXCEPTION:", err)
      this.props.notif.failed(err)
    } finally {
      this.setState({ disable_button_validate: false })
      setSubmitting(false)
    }
  }

  render() {
    if (!this.state.isReadyToRender) {
      this.dMgr.debug("render:", "not ready")
      return null
    }
    this.dMgr.rendering()

    let toRender = (
      <>
        <br />
        <Container>
          <Formik enableReinitialize initialValues={this.state.entity} validationSchema={this.getFormValidationSchema} onSubmit={this.lockAndSubmit}>
            {({ handleSubmit, handleChange, values, touched, errors, setFieldValue }) => (
              <Form noValidate onSubmit={handleSubmit} autoComplete="off">
                <Row>
                  <Col md={3}></Col>
                  <Col md={6}>
                    <Card className="bg-dark text-white box-shadow-lvl3">
                      <Card.Header>{this.props.t("nav.myProfile")}</Card.Header>
                      <Card.Body>
                        <Container fluid>
                          <Row>
                            <Col md={6}>
                              <Form.Group controlId="formFirstname">
                                <Form.Label>{this.props.t("form.firstname") + this.props.t("app.dbp")}</Form.Label>
                                <Field as={Form.Control} name="firstname" isInvalid={touched.firstname && errors.firstname} onChange={handleChange} value={values.firstname} />
                                <Form.Control.Feedback type="bgalid">
                                  <ErrorMessage name="firstname" />
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                            <Col md={6}>
                              <Form.Group controlId="formName">
                                <Form.Label>{this.props.t("form.name") + this.props.t("app.dbp")}</Form.Label>
                                <Field as={Form.Control} name="name" isInvalid={touched.name && errors.name} onChange={handleChange} value={values.name} />
                                <Form.Control.Feedback type="bgalid">
                                  <ErrorMessage name="name" />
                                </Form.Control.Feedback>
                              </Form.Group>
                            </Col>
                          </Row>
                          <br />
                          <Row>
                            <Col md={3}>
                              <Form.Label>{this.props.t("form.preferredLanguage") + this.props.t("app.dbp")}</Form.Label>
                            </Col>
                            <Col md={3}>
                              <Select
                                classNamePrefix="custom-react-select"
                                className={`react-select ${touched.preferredLanguage && errors.preferredLanguage ? "react-select-bgalid" : ""}`}
                                name="preferredLanguage"
                                options={Object.keys(this.props.i18n.options.availableLanguages).map((key) => {
                                  let IconCountry = CountryIcon[this.props.i18n.options.availableLanguages[key].flag]
                                  return {
                                    value: this.props.i18n.options.availableLanguages[key].lang,
                                    label: (
                                      <>
                                        <IconCountry className="lang_flag margin-right-5" />
                                      </>
                                    ),
                                  }
                                })}
                                defaultValue={
                                  values.preferredLanguage !== ""
                                    ? () => {
                                        // console.log("eeev", values.preferredLanguage);
                                        let IconCountry = CountryIcon[this.props.i18n.options.availableLanguages[values.preferredLanguage].flag]

                                        return {
                                          value: values.preferredLanguage,
                                          label: (
                                            <>
                                              <IconCountry className="lang_flag margin-right-5" />
                                            </>
                                          ),
                                        }
                                      }
                                    : ""
                                }
                                onChange={(e) => {
                                  setFieldValue("preferredLanguage", e.value)
                                }}
                              />
                              {touched.preferredLanguage && errors.preferredLanguage && <div className="bgalid-feedback d-block">{errors.preferredLanguage}</div>}
                            </Col>
                          </Row>
                          <br />
                          <br />
                          <Row>
                            <Col md={3}>{this.props.t("form.iamUsername") + this.props.t("app.dbp")}</Col>
                            <Col md={9}>
                              <b>{this.state.entity.iamUsername}</b>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>{this.props.t("form.email") + this.props.t("app.dbp")}</Col>
                            <Col md={9}>
                              <b>{this.state.entity.email}</b>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>{this.props.t("form.roles") + this.props.t("app.dbp")}</Col>
                            <Col md={9}>
                              <b>{this.state.entity.roles.join(", ")}</b>
                            </Col>
                          </Row>
                          <Row>
                            <Col md={3}>{this.props.t("form.departments") + this.props.t("app.dbp")}</Col>
                            <Col md={9}>
                              <b>{this.state.entity.departments.map((item) => item.name).join(", ")}</b>
                            </Col>
                          </Row>
                          <br />
                          <br />

                          <Row>
                            <Col md={4}></Col>
                            <Col md={2} className="text-center">
                              <Button onClick={() => this.props.goTo("dashboard")} variant="secondary" size="sm" className="margin-right-5">
                                {this.props.t("action.cancel")}
                              </Button>
                            </Col>
                            <Col md={2} className="text-center">
                              <Button variant="primary" size="sm" type="submit" disabled={this.state.disable_button_validate} className="margin-right-5">
                                {this.props.t("action.validate")}
                              </Button>
                            </Col>
                          </Row>
                        </Container>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Container>
      </>
    )

    this.dMgr.renderDone()
    return toRender
  }
}

export default withHooks(MyProfileForm)
